module.exports = __webpack_public_path__ + "media/src/img/payment/dollar-211b8a20b43c73fb30e2a257b1c0e08b.svg";